import { API_PATH } from '../../routes/generalPath';

export const ENQUETE_CONFIRM_PATH = {
  INDEX: API_PATH.ENQUETE_CONFIRM,
};
